import axios from "../axios";

export async function fetchVehicleDamageReports(params = {}) {
  const { vehicle_id, vehicleId, ...rest } = params;
  const vid = vehicle_id ?? vehicleId;
  const merged = { ...rest };
  if (vid != null && merged.vehicle_id == null) {
    merged.vehicle_id = vid;
  }
  return axios({ method: "get", url: "/vehicle_damage_reports", params: merged })
    .then((r) => r.data)
    .catch((e) => e.response?.data || e);
}

export async function createVehicleDamageReport(payload) {
  return axios
    .post("/vehicle_damage_reports", { vehicle_damage_report: payload })
    .then((r) => r.data)
    .catch((e) => e);
}


